
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { Agent } from "@/models/agent";
import { Tag } from "lucide-react";

interface TagsListProps {
  agents: Agent[];
  category: string;
  selectedTag?: string | null;
}

const TagsList: React.FC<TagsListProps> = ({ agents, category, selectedTag }) => {
  // Extract all unique tags from agents in this category
  const uniqueTags = Array.from(
    new Set(
      agents
        .filter(agent => agent.category.toLowerCase() === category.toLowerCase())
        .flatMap(agent => agent.tags)
    )
  );

  if (uniqueTags.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <h3 className="text-lg font-medium mb-3 flex items-center text-gray-800 dark:text-gray-200">
        <Tag className="h-4 w-4 mr-2 text-blue-600 dark:text-blue-400" />
        Popular Tags
      </h3>
      <div className="flex flex-wrap gap-2">
        {uniqueTags.map(tag => {
          const isSelected = selectedTag && selectedTag.toLowerCase() === tag.toLowerCase();
          
          return (
            <Badge 
              key={tag} 
              variant={isSelected ? "default" : "outline"} 
              className={`
                cursor-pointer transition-colors
                ${isSelected 
                  ? "bg-blue-50 text-blue-700 hover:bg-blue-100 border-blue-200 dark:bg-blue-900/50 dark:text-blue-200 dark:border-blue-800/50" 
                  : "bg-gray-50 text-gray-700 hover:bg-gray-100 border-gray-200 dark:bg-gray-800/30 dark:text-gray-300 dark:border-gray-700/50"}
              `}
            >
              <Link to={`/category/${encodeURIComponent(category)}?tag=${encodeURIComponent(tag)}`} className="px-1">
                {tag}
              </Link>
            </Badge>
          );
        })}
      </div>
    </div>
  );
};

export default TagsList;
